import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-gereedschap',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconGereedschap {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M4.05 8c-.36.03-.7-.14-.91-.44L.49 3.71C.2 3.29.25 2.71.6 2.35L2.29.61C2.64.25 3.2.2 3.61.49L7.4 3.22c.28.2.44.53.44.88l-.02 2.3 6.37 6.63-1.45 1.5-6.51-6.68L4.06 8Zm29.88 21.67a3.774 3.774 0 0 1 0 5.24c-.7.72-1.63 1.09-2.55 1.09s-1.85-.36-2.55-1.09L17.51 23.28l5.1-5.24zm-1.45 1.54-9.81-10.08-2.19 2.25 9.81 10.08c.29.3.68.47 1.09.47s.8-.17 1.09-.47c.6-.62.6-1.63 0-2.24Zm-2.62-14.67-4.35-4.47L4.23 33.7c-.71.73-1.77.81-2.48.08L.53 32.53a1.89 1.89 0 0 1 0-2.63L21.77 8.22l-4.28-4.43c-.4-.41-.4-1.08 0-1.5L19.38.35c.19-.2.45-.31.72-.31L25.02 0c.28 0 .54.11.74.31l9.94 10.24c.4.41.4 1.08 0 1.5l-4.37 4.49c-.4.41-1.05.41-1.46 0Zm.8-2.18 2.85-3.07-8.91-9.18-4.05.05-.82.92 10.94 11.27Z"/>
</svg>

    );
  }
}
